/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import useTheme from '@hooks/useTheme';

import { Table, Form, Popover, Switch, Tooltip } from 'antd';
import { number_format } from '@utils/widget';
import {
  getValueFromSearchParam,
  removeValueFromSearchParam,
  setURLSearchParam,
} from '@utils/history';
import { addHTTP, isUuid } from '@utils/common';
import { EditableCell, Save } from './editable'; // 这是往Action中添加edit功能的
import {
  GlobalEditableCell,
  SaveCancelButtons,
  GlobalEditButton,
} from './globalEditable';
import Action from './Action';
import { useSelector, useDispatch } from 'react-redux';
import action from '@flux/action';
import { insightMenuAcions, SEGMENTS, GotomarketDeafultFields } from '@model';
import KeyExecutives from './keyExecutives/index';
import { API } from '@service';
import { PowerBILinkWithIcon } from '../detail/subsidiaries/powerbiEmbed.js';
import classNames from 'classnames';
import KeyContactsTable from './keyContactsTable';
import D_Number from '@utils/number';
// import SectionComment from '@components/CommentCenter/SectionComment';
import SectionComment from 'src/ddvComment/SectionComment';

import {
  // CommentModuleKey,
  findAnalysisModuleKey,
} from '@components/directUser/data';
import AnalysisCommentAnchor from '@components/analysisCommentAnchor';
import { formatters } from '@modules/analysis/summary/financials';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';
import { filterXSS } from 'xss';

import './index.scss';

export const expandData = [
  'Sales and Marketing',
  'General and Administrative',
  'Financial Statement',
  'Dun & Bradstreet',
];

const ExpandButton = ({ changeExpandRow, rowIndex }) => {
  const [isExpand, toggleExpand] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    toggleExpand((state) => !state);

    changeExpandRow((rows) => {
      if (!isExpand) {
        return [...rows, rowIndex];
      }
      return rows.filter((row) => row !== rowIndex);
    });
  };

  return (
    <div className="expand-btn" onClick={handleClick}>
      <span
        className={`appkiticon  a-font-8 icon-${
          isExpand ? 'up' : 'down'
        }-chevron-fill`}
      />
    </div>
  );
};

const ExpandableCell = ({ children, expandable }) => (
  <div className={expandable ? 'expandable-cell' : ''}>{children}</div>
);

const formatCompanyName = (name) => {
  if (name?.length > 24) {
    const tempStr = name.trim().split(' ');
    tempStr.pop();
    const finaleStr = tempStr.join(' ');
    if (finaleStr.length > 24) {
      return formatCompanyName(finaleStr);
    }
    return finaleStr;
  }
  return name || '-';
};

const renderHeadcountSales = (data = {}) => {
  const { headcount, sales } = data || {};
  const formatSales = formatters.formatNumberToString(sales);
  return (
    <div className="textInoneLine headcount-sales">
      {D_Number.addSeparator(headcount) || '-'} /{' '}
      {formatSales && formatSales !== '-' ? `$${formatSales}` : '-'}
    </div>
  );
};

const CompanyLink = ({ link = {} }) => {
  if (!link.link) {
    return null;
  }

  return (
    <Popover
      placement="top"
      content={
        <a
          href={filterXSS(addHTTP(link.link, 'http://'))}
          target="_Blank"
          rel="noreferrer"
        >
          {link.tip || link.link}
        </a>
      }
    >
      <div className="company-link-wrapper">
        <span className="appkiticon icon-link-outline a-font-12" />
      </div>
    </Popover>
  );
};

const CompanyName = ({ name, link, selectedMenu, isManualCompany }) => (
  <div className="company-name">
    {formatCompanyName(name)}

    {(selectedMenu === 'Company Overview' || selectedMenu === 'Financials') &&
      isManualCompany && (
        <Tooltip title="To update company information for this company, navigate to Project Home, click the Settings icon, and click ‘Next’.">
          <span style={{ margin: '0 0.313rem' }}>
            <span className="appkiticon icon-information-fill" />
          </span>
        </Tooltip>
      )}
    <CompanyLink link={link} />
  </div>
);

const couldExpand = (record) => {
  const rows = document.querySelectorAll('.ant-table-row');

  Array.from(rows).forEach((rowEle) => {
    const cells = Array.from(rowEle.querySelectorAll('.expandable-cell'));
    const addClassname = 'show-expand-icon';
    let expandable = false;

    for (const cellEle of cells) {
      if (cellEle.firstChild.offsetHeight > rowEle.offsetHeight - 32) {
        expandable = true;
        break;
      }
    }

    findDOMNode(rowEle).className = `${rowEle.className.replace(
      addClassname,
      '',
    )} ${expandable ? addClassname : ''}`.trim();
  });
};

const AnalysisSummary = ({
  data,
  changeResource,
  refetch,
  resourceName,
  selectedMenu,
  showModal,
  dropdownList,
  hasComment,
  currentSubmoduleName,
  isGlobalEditing,
  setIsGlobalEditing,
  isSettingOpen,
}) => {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const [tableContent, setTableContent] = useState([]);
  const [columns, setColumns] = useState([]);
  const [choosedItemIndex, setChoosedItemIndex] = useState(null);
  const [openedInsight, setOpenedInsight] = useState(undefined);
  const [indexOfIsediting, setIndexOfIsEditing] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [expandRows, changeExpandRow] = useState([]);
  const [switchActive, setSwitchActive] = useState(true);
  useEffect(() => {
    setIndexOfIsEditing(null);
  }, [isSettingOpen]);
  useEffect(() => {
    if (data) {
      const initialSwitch = getValueFromSearchParam('ltmSwitch')?.ltmSwitch;
      setSwitchActive(initialSwitch);
      if (dropdownList?.length) {
        setDropListItem(dropdownList[initialSwitch ? 1 : 0]);
      }
    }
  }, [data]);
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const history = useHistory();

  const dispatch = useDispatch();

  const setShowKeyContacts = (bool) => {
    dispatch(action.setShowKeyContacts(bool));
  };

  const editRow = (index) => () => {
    setIndexOfIsEditing(index);
  };

  const [dropListItem, setDropListItem] = useState(
    Array.isArray(dropdownList) && dropdownList[0],
  );
  const [leftData, setLeftData] = useState(() => {
    if (selectedMenu === 'Financials') {
      return data.tableForLTM;
    }
    return data.table;
  });

  const {
    projectId,
    /* projectDetail, */ isShowContacts,
    buyerLabel,
    targetLabel,
    buyerName,
    targetName,
  } = useSelector(({ common, analysis, projects }) => ({
    projectId: common.currentId,
    isShowContacts: analysis.isShowContacts,
    // projectDetail: {
    //   projectInfo: {
    //     buyerName: common?.projectCompanyInfo?.buyerName,
    //     targetName: common?.projectCompanyInfo?.targetName,
    //   },
    // },
    buyerName: common?.projectCompanyInfo?.buyerName || '',
    targetName: common?.projectCompanyInfo?.targetName || '',
    buyerLabel: common.projectCompanyInfo.buyerLabel,
    targetLabel: common.projectCompanyInfo.targetLabel,
  }));

  const getColumnTitle = (fieldname) =>
    ({
      info: 'field',
      buyer: buyerLabel,
      target: targetLabel,
    }[fieldname] || fieldname);

  const inputEls = { buyer: useRef(null), target: useRef(null) };
  const [form] = Form.useForm();
  const submitForm = async (text) => {
    const formData = ['buyer', 'target'].reduce(
      (acc, fieldName) =>
        Object.assign({}, acc, {
          [fieldName]: inputEls[fieldName].current.input.value,
        }),
      {},
    );
    if (!isUuid(text.resourceId)) {
      const infoType = text.info;
      setIsLoading(true);
      await API.submitFiscalYearEnd(projectId, formData, infoType);
      setIsLoading(false);
      setIndexOfIsEditing(null);
      refetch();
    } else {
      setIsLoading(true);
      await API.submitCompanyOverviewCustomizeValues(
        projectId,
        formData,
        text.resourceId,
      );
      setIsLoading(false);
      setIndexOfIsEditing(null);
      refetch();
    }
  };

  const getValueOfField = (field) => {
    if (!(field instanceof Object)) {
      return undefined;
    }
    if (!(field.info instanceof Object)) {
      return undefined;
    }
    return field.info.value.replace(/\_/g, '/');
  };

  // const checkHasProperty = (property) => (value) =>
  //   data.some((d) => getValueOfField(d) === value && d.info[property] === true);

  // const checkIsLinked = checkHasProperty('clickable');
  // const checkIsEditable = checkHasProperty('editable');
  // const checkIsGLobalEditable = checkHasProperty('globalEdit');

  const getResourceId = (resourceName) => {
    const resource =
      Array.isArray(leftData) &&
      leftData.find((d) => getValueOfField(d) === resourceName);
    if (resource) {
      return resource.info.resourceId;
    }
    return null;
  };

  const getResourceIndex = (resourceName) => {
    const index =
      Array.isArray(leftData) &&
      leftData.findIndex((d) => getValueOfField(d) === resourceName);
    if (index) {
      return index;
    }
    return 0;
  };

  const clickedItemHandler = useCallback((clickedItem, keepSearchParam) => {
    const resourceName = clickedItem.info;
    const resourceId = getResourceId(resourceName);
    const searchParams = new URLSearchParams(history.location.search);
    searchParams.set('resourceId', resourceId);
    if (!keepSearchParam) {
      [
        searchParamKeys.tab,
        searchParamKeys.view,
        searchParamKeys.futureState,
        searchParamKeys.integrationTabId,
        searchParamKeys.expand,
      ].forEach((i) => searchParams.delete(i));
    }
    history.replace({
      ...history.location,
      search: `?${searchParams.toString()}`,
    });
    changeResource(resourceId, resourceName);
  }, []);

  const markData = [
    'Financial Statement',
    'Dun & Bradstreet',
    'LE Subsidiaries',
  ].filter((e) =>
    leftData ? !leftData[getResourceIndex(e)]?.info.hideFlag : true,
  );

  useEffect(() => {
    if (tableContent?.length) {
      const searchParams = new URLSearchParams(history.location.search);
      const resourceId = searchParams.get('resourceId');
      let targetResource, targetIndex;
      for (let i = 0; i < tableContent.length; i++) {
        if (tableContent[i].resourceId === resourceId) {
          targetResource = tableContent[i];
          targetIndex = i;
          break;
        }
      }
      if (
        targetResource &&
        resourceId &&
        targetResource?.clickable &&
        !targetResource?.hideFlag
      ) {
        setChoosedItemIndex(targetIndex);
        clickedItemHandler(targetResource, true);
      }
    }
  }, [tableContent]);

  // build left table data
  const buildTableColumn = useCallback(
    (datas) => {
      const columns = [];
      // title是第一行，其余的是column,datas[0]就是所有data
      const isFinancials = selectedMenu === SEGMENTS.financials;
      for (const fieldName in datas[0]) {
        if (fieldName === 'info') {
          columns.push({
            title: () =>
              isFinancials ? (
                <div>
                  <div className="capitalize-title">
                    {getColumnTitle(fieldName)}
                  </div>
                  <span
                    className={`switch-text ${
                      !switchActive && 'switch-active'
                    }`}
                  >
                    {dropdownList[0]}
                  </span>

                  <Switch
                    className="LTM-FY2020"
                    checked={switchActive}
                    onChange={(checked) => {
                      setSwitchActive(checked);
                      if (checked) {
                        setURLSearchParam(history, { ltmSwitch: true });
                      } else {
                        removeValueFromSearchParam(history, ['ltmSwitch']);
                      }
                      setDropListItem(dropdownList[checked ? 1 : 0]);
                    }}
                  />
                  <span
                    className={`switch-text ${switchActive && 'switch-active'}`}
                  >
                    {dropdownList[1]}
                  </span>
                </div>
              ) : (
                <div className="capitalize-title">
                  {getColumnTitle(fieldName)}
                </div>
              ),
            dataIndex: fieldName,
            key: fieldName,
            render: (text, record, rowIndex) => {
              const isLinked = record.clickable;
              // const hasInsight = record.hasInsight;
              const hasInsight = false;
              const hasMark = text === 'LE Subsidiaries';
              const hasMargin = expandData.includes(text);
              const classes = classNames({ hasdot: hasInsight, hasMargin });

              const renderText = (text) => {
                if (markData.includes(text)) {
                  return (
                    <>
                      <span className={classes}>{text}</span>
                      <span className="mark">
                        {selectedMenu === SEGMENTS.companyoverview
                          ? markData.findIndex((item) => item === text) + 1
                          : 1}
                      </span>
                    </>
                  );
                }
                return <span className={classes}>{text}</span>;
              };

              const expandable = record.expandable;
              if (isLinked) {
                return (
                  <React.Fragment>
                    <span className={`link-text ${classes}`}>
                      {renderText(text)}
                    </span>
                    {hasMark && (
                      <>
                        <PowerBILinkWithIcon />
                      </>
                    )}
                    <br />
                    {record.date && (
                      <span className="market-cap">{`Last Updated ${record.date}`}</span>
                    )}
                  </React.Fragment>
                );
              }

              if (expandable && !isGlobalEditing) {
                return (
                  <div
                    className={`expandable-cell-title ${
                      hasInsight ? 'hasdot' : ''
                    }`}
                  >
                    {text}
                    <ExpandButton
                      rowIndex={rowIndex}
                      changeExpandRow={changeExpandRow}
                    />
                  </div>
                );
              }
              return renderText(text);
            },
          });
        } else {
          columns.push({
            title: () => (
              <div className="added-company-name">
                {getColumnTitle(fieldName)}

                {fieldName === 'buyer' ? (
                  <CompanyName
                    name={buyerName}
                    link={isFinancials && data?.buyer}
                    selectedMenu={selectedMenu}
                    isManualCompany={data?.buyerManualInputFlag}
                  />
                ) : (
                  <CompanyName
                    name={targetName}
                    link={isFinancials && data?.target}
                    selectedMenu={selectedMenu}
                    isManualCompany={data?.targetManualInputFlag}
                  />
                )}
              </div>
            ),
            dataIndex: fieldName,
            key: fieldName,
            render: (text, record, index) => {
              const expandable = record.expandable;
              if (selectedMenu === SEGMENTS.keycontact) {
                // console.log(text);
                if (Array.isArray(text)) {
                  return <KeyContactsTable data={text} />;
                }
                return <div>{text}</div>;

                // if (Array.isArray(text)) {
                //   return text.map((item, idx) =>
                //     item.shouldDisplay ? (
                //       item.linkedin ? (
                //         <Popover
                //           placement="topLeft"
                //           content={
                //             <a
                //               href={addHTTP(item.linkedin, 'http://')}
                //               target="_Blank"
                //               rel="noreferrer"
                //             >
                //               {item.linkedin}
                //             </a>
                //           }
                //           key={idx}
                //         >
                //           <div>
                //             <p className="key-contacts-text">
                //               {item.title}:{' '.replace(/ /g, '\u00a0')}
                //               {item.name}
                //             </p>
                //           </div>
                //         </Popover>
                //       ) : (
                //         <div>
                //           <p className="key-contacts-text">
                //             {item.title}:{' '.replace(/ /g, '\u00a0')}
                //             {item.name}
                //           </p>
                //         </div>
                //       )
                //     ) : null,
                //   );
                // }
                // return <div>{text}</div>;
              }
              // if (record.info && record.info === 'Employee Headcount') {
              //   return (
              //     <div className="textInoneLine">{number_format(text)}</div>
              //   );
              // }
              if (record.info && record.info === 'LE Subsidiaries') {
                text =
                  text && number_format(text.substring(0, text.length - 13));
                return (
                  <div className="textInoneLine">
                    {text ? `${text} Subsidiaries` : '-'}
                  </div>
                );
              }
              if (
                (record.info && record.info === 'Financial Statement') ||
                record.info === 'Dun & Bradstreet'
              ) {
                return (
                  <div className="textInoneLine">
                    {D_Number.addSeparator(text) || '-'}
                  </div>
                );
              }
              if (record.info && record.info === 'Employee Headcount') {
                return <div className="textInoneLine" />;
              }

              if (record.globalEdit) {
                return (
                  <ExpandableCell expandable={expandable && !isGlobalEditing}>
                    <GlobalEditableCell
                      value={text}
                      defaultValue={text}
                      isEditing={isGlobalEditing}
                      selectedMenu={selectedMenu}
                      // name={`${record.info}[${fieldName}]`}
                      name={[record.info, fieldName]}
                    />
                  </ExpandableCell>
                );
              }
              if (record.editable || isUuid(record.resourceId)) {
                return (
                  <EditableCell
                    value={text}
                    defaultValue={text}
                    isEditing={indexOfIsediting === index}
                    ref={inputEls[fieldName]}
                    addClassName={
                      record.info === 'Note' ? 'noteWidth' : 'customize-field'
                    }
                  />
                );
              }
              if (
                record.info &&
                (record.info === 'Competitors' ||
                  (selectedMenu === SEGMENTS.operationalfootprint &&
                    record.info === 'Locations') ||
                  record.info === 'Company Description') &&
                !text
              ) {
                return <div className="textInoneLine">-</div>;
              }
              if (
                selectedMenu === SEGMENTS.companyoverview &&
                record.info === 'Company Website' &&
                text !== '-'
              ) {
                return (
                  <a
                    href={addHTTP(text, 'http://')}
                    style={{ color: isLightMode ? '#252525' : '#dbdbdb' }}
                    target="_Blank"
                    rel="noreferrer"
                  >
                    {text}
                  </a>
                );
              }
              if (
                selectedMenu === SEGMENTS.gotomarket &&
                record.info === 'Competitors'
              ) {
                return (
                  <ExpandableCell expandable={expandable}>
                    <div>
                      {text.split('; ').map((item, index) => (
                        <div className="textInoneLine" key={index}>
                          {item}
                        </div>
                      ))}
                    </div>
                  </ExpandableCell>
                );
              }
              if (
                record.resourceId === 'currency' &&
                text !== 'USD' &&
                text !== '-'
              ) {
                return (
                  <span className="textInoneLine rounded-text">{text}</span>
                );
              }
              if (record.value === 'Headcount _ Sales by Country') {
                return renderHeadcountSales(record[fieldName]);
              }
              return <div className="textInoneLine">{text ? text : '-'}</div>;
            },
          });
        }
      }
      columns.push({
        // title: () => <AccessIndicator page={selectedMenu} />,
        key: 'action',
        width: hasComment ? 100 : undefined,
        render: (text, record, index) => {
          const list = [
            // insightMenuAcions.ADDINSIGHT,
            // insightMenuAcions.VIEWINSIGHT,
          ];

          // if (!isInternal) {
          //   list.shift();
          // } else {
          if (
            record.editable ||
            (isUuid(record.resourceId) &&
              ![SEGMENTS.gotomarket].includes(selectedMenu))
          ) {
            list.unshift(insightMenuAcions.EDIT);
          }
          // }
          // if (!record.hasInsight) {
          //   list.pop();
          // }
          if (index === indexOfIsediting) {
            return (
              <Save
                actionHandler={() => submitForm(text)}
                isLoading={isLoading}
              />
            );
          }
          return (
            // the last column for comment and insight action
            <div className="operation-cell">
              <SectionComment
                module={currentSubmoduleName}
                component={record.value.replace(/\_/g, '/')}
                placement="topRight"
              />
              <AnalysisCommentAnchor record={record} />
              {list && list.filter((item) => item).length > 0 ? (
                <Action
                  list={list}
                  index={index}
                  activeIndex={openedInsight}
                  openFunc={list.length > 0 ? setOpenedInsight : () => {}}
                  editRow={editRow(index)}
                  showModal={showModal}
                  category={record.info}
                  uuid={
                    record.resourceIdFy
                      ? record.resourceIdFy
                      : record.resourceId
                  }
                />
              ) : (
                <div style={{ width: 5 }} />
              )}
            </div>
          );
        },
      });
      setColumns(columns);
    },
    [
      openedInsight,
      indexOfIsediting,
      isLoading,
      isGlobalEditing,
      switchActive,
      hasComment,
      leftData,
      buyerName,
      targetName,
      buyerLabel,
      targetLabel,
    ],
  );

  const buildTableContent = (datas) => {
    const tableContent =
      Array.isArray(datas) &&
      datas.map((data = {}, idx) => {
        let row = {};
        row.key = idx;
        columns.map((column) => {
          if (data[column.key]) {
            row[column.key] = data[column.key].value
              ? data[column.key].value.replace(/\_/g, '/')
              : data[column.key];
          }
          //add clickable,editable...into records
          row = {
            ...(data.info || {}),
            ...row,
          };

          return column;
        });
        return row;
      });
    setTableContent(tableContent);
  };
  useEffect(() => {
    setChoosedItemIndex(getResourceIndex(resourceName));
    if (selectedMenu === 'Financials') {
      dropListItem === 'LTM'
        ? setLeftData(data.tableForLTM)
        : setLeftData(data.table);
    } else {
      setLeftData(data.table);
    }
  }, [tableContent, data, dropListItem]);

  useEffect(() => {
    if (leftData && leftData.length) {
      buildTableColumn(leftData);
    }
  }, [leftData, buildTableColumn, isGlobalEditing, resourceName]);

  useEffect(() => {
    if (leftData && columns.length) {
      buildTableContent(leftData);
    }
  }, [columns, leftData, isGlobalEditing, resourceName]);

  useEffect(() => {
    if (selectedMenu !== SEGMENTS.gotomarket) {
      return;
    }
    couldExpand();
  });

  // saveHandler
  // 提交表单统一数据请求函数
  const onFinish = async (res) => {
    setIsLoading(true);
    const requestData = Object.keys(res).map((item) => {
      !res[item].buyer && (res[item].buyer = '');
      !res[item].target && (res[item].target = '');
      res[item].buyer.trim() === '' && (res[item].buyer = '');
      res[item].target.trim() === '' && (res[item].target = '');
      // 以上判断输入的值是否为空格或全是回车
      return {
        keyword: item.replace(/\//g, '_'),
        ...res[item],
      };
    });
    if (selectedMenu === SEGMENTS.keycontact) {
      // 这是Key Contacts页面提交时请求的数据
      await API.postKeyContactsData(projectId, requestData);
    } else {
      const postContentList = Object.keys(res).map((item) => ({
        keyword: item,
        ...res[item],
      }));
      const defaultFields = [];
      const custmoizeFields = [];

      postContentList.forEach((e) => {
        if (GotomarketDeafultFields.includes(e.keyword)) {
          defaultFields.push(e);
        } else {
          custmoizeFields.push(e);
        }
      });

      const requestDataForGoToMarket = {
        defaultFields,
        custmoizeFields,
      };
      await API.postGoToMarket(projectId, requestDataForGoToMarket);
      changeExpandRow([]);
    }

    setIsGlobalEditing(false);
    setIsLoading(false);
    form.resetFields();
    refetch();
  };

  const cancelHandler = (e) => {
    form.resetFields();
    setIsGlobalEditing(false);
    changeExpandRow([]);
  };

  // columns 左侧每竖行对应的数据标识
  return (
    <>
      <div className={`analysisSummaryContainer ${selectedMenu}`}>
        <Form form={form} onFinish={onFinish} autoComplete="off">
          {isShowContacts ? (
            <KeyExecutives companyNames={{ buyerName, targetName }} />
          ) : (
            <Table
              className={selectedMenu === 'Key Contacts' ? 'keyContacts' : null}
              dataSource={tableContent}
              columns={columns}
              pagination={false}
              loading={false}
              rowClassName={(record, index) => {
                let className = '';

                if (index === choosedItemIndex) {
                  className = `${className} active-item`;
                }

                if (expandRows.includes(index)) {
                  className = `${className} is-expand`;
                }

                if (record.hideFlag) {
                  className = `${className} hidden-category`;
                }
                return className;
              }}
              onRow={(record, rowIndex) => ({
                onClick: (event) => {
                  const isClicked = record.clickable;
                  if (isClicked) {
                    setChoosedItemIndex(rowIndex);
                    clickedItemHandler(record);
                  }
                },
              })}
              scroll={{ y: 'calc(100% - 4.563rem)' }}
            />
          )}
        </Form>
      </div>
      <SaveCancelButtons
        form={form}
        selectedMenu={selectedMenu}
        cancelHandler={cancelHandler}
        isEditing={isGlobalEditing}
        isLoading={isLoading}
      />
    </>
  );
};

export default React.memo(AnalysisSummary);
